import { render } from "./EditProduct.vue?vue&type=template&id=3462fa17"
import script from "./EditProduct.vue?vue&type=script&lang=js"
export * from "./EditProduct.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./EditProduct.vue?vue&type=style&index=0&id=3462fa17&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__